import { Accordion, AccordionItem } from "@nextui-org/accordion";

export default function FaqSection({ faq }) {
  const faqItems = [
    {
      id: 1,
      name: 'اگر اثر نقاشی یا عکاسی رو در سایت پیدا نکردم میتونم سفارش بدم؟',
      value:
        'آره با کمال میل، شما میتونین با پشتیبانی تونالیته ارتباط بگیرین و فایل اثر رو ارسال کنید. مهم نیست که فایلتون کم حجم باشه.'
    },
    // {
    //   id: "2",
    //   name: 'من الان تابلو رو میخوام تاریخ تحویل شما چند روزست؟',
    //   value:
    //     'اگر الان تابلو رو میخواین میتونین از بخش تابلوهای آماده بازدید کنید. در این بخش علاوه بر تابلوهای آماده تحویل تعدادی هم مجموعه کنار هم قرار گرفته که میتونین براشون در دیزاینتون استفاده کنید. اگر هم چند روزی زمان دارین میتونن از بخش اصلی سایت استفاده کنین و تابلوتون رو سفارشی سازی کنین. تعداد روزهای تحویل وابسطه به سفارشتون قبل از ثبت سفارش بهتون اعلام میشه.'
    // },
    {
      id: 3,
      name: 'از چه طریقی می‌توانم وضعیت سفارشاتم را پیگیری کنم؟',
      value:
        'با مراجعه به پنل کاربریتون اینکه سفارشتون در چه مرحله‌ای هست رو میتونین ببینین.'
    },
    {
      id: 4,
      name: 'چطور از کیفیت کار نهایی مطمئن بشیم؟',
      value:
        'ما با دستگاه چاپ پیشرفته کار میکنیم ولی همه‌ی تابلوها به صورت دستی اصلاح رنگ میشن و مطمئنا خودمون نهایت سختگیری رو قبل از ارسال میکنیم ولی اگر ناراضی بودین لطفا به پشتیبانی اعلام کنین که یا هزینه رو خدمتتون بازگشت بدیم یا اینکه مجددا براتون آماده و ارسال کنیم.'
    },
    {
      id: 5,
      name: 'میتونم ازتون برای انتخاب اثر یا نحوه کارکردن با سایت مشورت بگیرم؟',
      value:
        'با کمال میل کاشناسان تونالیته منتظر تماس شما هستند. برای کار کردن با سایت هم میتونین ویدئو زیر رو ببینین'
    },
    {
      id: 6,
      name: 'برای خارج از کشور ارسال دارین؟',
      value:
        'آره میتونیم براتون ارسال کنیم. لطفا به پشتیبانی اعلام کنید. '
    },
  ];

  return (
    <section className="container w-full my-12" dir='rtl'>
      <Accordion>
        {(faq || faqItems).map((item) => (
          <AccordionItem
            className="[&>h2>button>div>span]:font-bold"
            key={item.id}
            aria-label={`Accordion ${item.id}`}
            title={item.name}
          >
            {item.value}
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
